import { RouteObject } from "react-router-dom";

export const routes: RouteObject[] = [
    { path: '/login' },
    { path: '/signup' },
    { path: '/error' },
    { path: '/:eventAlias/*' },
    { path: '/profile' },
    { path: '/' },
    { path: '/quiz-selector' },
    { path: '/root-quiz-selector' },
    { path: '/quiz/create' },
    { path: '/quiz/:quizId/*' },
    { path: '/table-demo' },
    { path: '*' },
];